import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'sortNumberArray'
})

@Injectable()
export class SortBigestNumberArray implements PipeTransform {
    transform(array: any[], field: string, descending?: boolean): any[] {
      if(descending === true){
        array.sort((a: any, b: any) => {
          if (a < b) {
            return -1;
          } else if (a > b) {
            return 1;
          } else {
            return 0;
          }
        });
      } else {
        array.sort((a: any, b: any) => {
          if (a > b) {
            return -1;
          } else if (a < b) {
            return 1;
          } else {
            return 0;
          }
        });
      }
        return array;
      }
}